/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDepartmentList() {
        return HttpService.get(environment.API_DEPARTMENT_LIST);
    },
    searchRiskRegisterTab1(params) {
        return HttpService.get(environment.API_RISK_REGISTER + '/ropa', {
            params,
        });
    },
    searchRiskRegisterTab2(params) {
        return HttpService.get(environment.API_RISK_REGISTER + `/registered`, {
            params,
        });
    },
    deleteRiskRegister(params) {
        return HttpService.delete(environment.API_RISK_REGISTER, {
            params,
        });
    },
    getStatus(params) {
        return HttpService.get(environment.API_GET_STATUS, {
            params,
        });
    },
    getRiskListTab(riskId) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/tabs/' + riskId
        );
    },
    getImpactType(riskAssessmentId) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/impact-type/' + riskAssessmentId
        );
    },
    getImpactLevel(riskMapTopicId) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/impact-level/' + riskMapTopicId
        );
    },
    getLikelihood(riskAssessmentId) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/likelihood/' + riskAssessmentId
        );
    },
    getImpactScore(payload) {
        return HttpService.post(
            environment.API_RISK_REGISTER + '/score',
            payload
        );
    },
    getRiskRegisterDetail(id) {
        return HttpService.get(environment.API_RISK_REGISTER + '/detail/' + id);
    },
    createRiskRegisterDetail(payload) {
        return HttpService.post(
            environment.API_RISK_REGISTER + '/detail',
            payload
        );
    },
    updateRiskRegisterDetail(payload) {
        return HttpService.put(
            environment.API_RISK_REGISTER + '/detail',
            payload
        );
    },
    getRiskRegisterHeader() {
        return HttpService.get(environment.API_RISK_REGISTER + '/header');
    },

    //History
    getHistories(params) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/history/list',
            {
                params,
            }
        );
    },

    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/history/detail',
            {
                params,
            }
        );
    },

    createRiskRegisterInitial(payload) {
        return HttpService.post(
            environment.API_RISK_REGISTER + '/initial',
            payload
        );
    },
    getDetailInfo(riskRegisterId) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/' + riskRegisterId
        );
    },
    // connect
    connect(payload) {
        return HttpService.post(
            environment.API_RISK_REGISTER + '/activity/mapping',
            payload
        );
    },
    cloning(payload) {
        return HttpService.post(
            environment.API_RISK_REGISTER + '/clone',
            payload
        );
    },
    changeStatus(payload) {
        return HttpService.post(
            environment.API_RISK_REGISTER + '/status',
            payload
        );
    },
    // Activity
    deleteActivity(riskRegisterId, activityId) {
        return HttpService.delete(
            environment.API_RISK_REGISTER +
                `/${riskRegisterId}/activity/${activityId}`
        );
    },
    getActivityList() {
        return HttpService.get(environment.API_RISK_REGISTER + `/activity`);
    },
    saveActivity(payload) {
        return HttpService.put(
            environment.API_RISK_REGISTER + '/activity',
            payload
        );
    },
};
